export class SetToolSearch {
    static readonly type = '[ToolSearch] set';
    constructor(public data: any) { }
}
